import React from "react";
import "./SkeletonSignupForm.css";

const SkeletonSignupForm = () => {
  return (
    <div className="skeleton-container">
      <div className="skeleton-title skeleton-shimmer" style={{ width: "70%", height: "20px" }}></div>
      <div className="skeleton-subtext skeleton-shimmer" style={{ width: "40%", height: "15px" }}></div>

      <div className="skeleton-field skeleton-shimmer"></div>
      <div className="skeleton-field skeleton-shimmer"></div>
      <div className="skeleton-field skeleton-shimmer"></div>

      <div className="skeleton-checkbox skeleton-shimmer"></div>
      <div className="skeleton-small-text skeleton-shimmer" style={{ width: "70%" }}></div>

      <div className="skeleton-captcha skeleton-shimmer"></div>
      <div className="skeleton-button skeleton-shimmer"></div>
    </div>
  );
};

export default SkeletonSignupForm;
